import axios from "axios";
import { STARTING_POSITIONS } from "../StartingPositions";
import { Position, Settings, User } from "../models";
import { LoggedOutStorage } from "../ZustandState";

export const fetchPositions = async (): Promise<Position[]> => {
    try {
        const response = await axios.get(`${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_positions`, {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        });

        const fetchedPosition: Position[] = response.data;
        const sortedPositions = fetchedPosition.sort((a, b) => (a.index || 0) - (b.index || 0));

        return sortedPositions as Position[];
    } catch (error) {
        console.log("error:", error);
        return [];
    }
};

export const fetchPositionsForMenu = async (
    user: User | undefined,
    settings: Settings,
    loggedOutData?: LoggedOutStorage
): Promise<Position[]> => {
    if (!user) {
        let startingPositions = Object.values(STARTING_POSITIONS);
        startingPositions[0].rating = loggedOutData?.whiteRating || settings.startRating;
        startingPositions[0].numAttempts = loggedOutData?.whiteAttempts.length || 0;
        startingPositions[0].startRating = settings.startRating;
        startingPositions[1].rating = loggedOutData?.blackRating || settings.startRating;
        startingPositions[1].numAttempts = loggedOutData?.blackAttempts.length || 0;
        startingPositions[1].startRating = settings.startRating;
        return Object.values(STARTING_POSITIONS);
    }

    const positions = await fetchPositions();

    return positions;
};

export const putPositions = async (positions: Position[], startRating?: number) => {
    const response = await axios.put(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_positions`,
        { positions, startRating },
        {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        }
    );
    return response.data;
};
